(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-benefits"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('scroll', function(e) {
      startSwiper('#product-benefits-slider', {
        navigation: {
          nextEl: ".product-benefits__button-next",
          prevEl: ".product-benefits__button-prev",
        },
        loop: false,
        breakpoints: {
          0: {
            slidesPerView: 1.5,
            spaceBetween: 70
          },
          500: {
            slidesPerView: 2.5,
            spaceBetween: 24
          },
          625: {
            slidesPerView: 3.5,
            spaceBetween: 24
          },
          750: {
            slidesPerView: 4.5,
            spaceBetween: 24
          },
          990: {
            slidesPerView: 6,
            spaceBetween: 24
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"]) return;
  try {
    
var allTabBtns = document.querySelectorAll('.product-tabs__nav-btn');
if(allTabBtns.length){
  allTabBtns.forEach((button) => {
    button.addEventListener('click',function(){
      allTabBtns.forEach((btn) => {
        if(btn.dataset.tab == button.dataset.tab){
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
      document.querySelectorAll('.product-tabs__content-tab').forEach((tab) => {
        tab.classList.remove('active');
        if(tab.getAttribute('id') == button.dataset.tab){
          tab.classList.add('active');
        } else {
          tab.classList.remove('active');
        }
      });
    });
  });
}
  $(document).ready(function(){
    //console.log('test');
    var warHtml = $(".product-tabs__content-inner .warranty .grid__item").html();
    warHtml = $.trim(warHtml);
    if(warHtml == ""){
      //console.log('Entered');
      $(".product-tabs__nav-btn.enable__warranty").css("display","none");
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-wildwood-tabs"] && !window.DesignMode) return;
  try {
    
var allTabBtns = document.querySelectorAll('.product-tabs__nav-btn');
if(allTabBtns.length){
  allTabBtns.forEach((button) => {
    button.addEventListener('click',function(){
      allTabBtns.forEach((btn) => {
        if(btn.dataset.tab == button.dataset.tab){
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
      document.querySelectorAll('.product-tabs__content-tab').forEach((tab) => {
        tab.classList.remove('active');
        if(tab.getAttribute('id') == button.dataset.tab){
          tab.classList.add('active');
        } else {
          tab.classList.remove('active');
        }
      });
    });
  });
}


  } catch(e) { console.error(e); }
})();
})();
